export default __webpack_public_path__ + "static/media/ATM_signup_ad.b83a42ab.jpg";